import { State } from 'app/gamma/src/modules/types';
import { EnterpriseModel } from 'app/gamma/src/types/models';
import { getMe } from './members';
import { getMyTeams } from './teams';
import { isPaidManagedEnterpriseMember as isPaidManagedEnt } from '@trello/members';
import {
  OrganizationFeatures,
  OrganizationFeature,
} from '@trello/product-features';

export const isLoading = (state: State) => state.models.enterprises.isLoading;

export const getEnterpriseById = (
  state: State,
  idEnterprise: string,
): EnterpriseModel | undefined =>
  state.models.enterprises.collection[idEnterprise];

export const getMyEnterprises = (state: State): EnterpriseModel[] => {
  const me = getMe(state);
  if (me && me.enterprises) {
    return me.enterprises;
  }

  return [];
};

export const getAdminEnterprises = (state: State): EnterpriseModel[] => {
  const me = getMe(state);
  if (!me) {
    return [];
  }
  const { idEnterprisesAdmin = [] } = me;

  return idEnterprisesAdmin
    .map((id) => getEnterpriseById(state, id))
    .filter((enterprise) => !!enterprise) as EnterpriseModel[];
};

export const hasEnterprises = (state: State): boolean => {
  const enterprises = getMyEnterprises(state);

  return !!enterprises && !!enterprises.length;
};

export const isEnterpriseAdmin = (state: State): boolean => {
  const me = getMe(state);

  return !!(
    me &&
    me.confirmed &&
    me.idEnterprisesAdmin &&
    me.idEnterprisesAdmin.length > 0
  );
};

export const isManagedEnterpriseMember = (state: State): boolean => {
  const me = getMe(state);
  return !!(me && me.confirmed && me.idEnterprise);
};

export const isPaidManagedEnterpriseMember = (state: State) => {
  const me = getMe(state);
  if (!me) {
    return false;
  }

  return isPaidManagedEnt({
    confirmed: me.confirmed,
    idEnterprise: me.idEnterprise,
    organizations: getMyTeams(state),
  });
};

export const isEnterpriseMemberOnNonEnterpriseTeam = (state: State) => {
  return (
    isPaidManagedEnterpriseMember(state) &&
    getMyTeams(state).some((team) => {
      return Boolean(
        !team.idEnterprise ||
          (team.idEnterprise &&
            !OrganizationFeatures.isFeatureEnabled(
              OrganizationFeature.EnterpriseUI,
              team.products && team.products[0],
            )),
      );
    })
  );
};
